<p-toast></p-toast>
<div class="global-main-big-table" *ngIf="transactionsPendients">
  <p-table id="tableTransactionsPendients" #dtTransactionsPendients [value]="transactionsPendients"
    [tableStyle]="{ 'min-width': '55rem' , 'margin-top':'1.5%' }" [paginator]="true" [rows]="6" [sortField]="'date'"
    [sortOrder]="-1" [rowsPerPageOptions]="[1, 2, 3, 4 , 5 , 6]" selectionMode="single" autocomplete="off"
    class="global-table">
    <ng-template pTemplate="header">
      <tr>
        <th>Fecha</th>
        <th>Transacción</th>
        <th>Divisas</th>
        <th>Cantidad</th>
        <th>Precio</th>
        <th>Monto</th>
        <th>Cliente</th>
        <th>Acciones</th>
        <th *ngIf="canEdit">Editar</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction let-i="rowIndex">
      <tr>
        <td>{{ transaction.date | date: 'dd/MM/yyyy'}}</td>
        <td>{{ transaction.type_transaction.name }}</td>
        <td>{{ transaction.pair.name }}</td>
        <td>{{ formatNumber(transaction.quantity) }}</td>
        <td>{{ formatNumber(transaction.price) }}</td>
        <td>{{ formatNumber(transaction.mount) }}</td>
        <td>{{ transaction.customer.name }}</td>
        <td>
        <div class="optionsButtons">
        <button pButton 
            (click)="finalyTransaction(transaction)" 
            icon="pi pi-check"
            class="p-button-rounded p-button-text">
        </button>
        <button pButton 
            (click)="deletetransaction(transaction)" 
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text">
         </button>
        </div>
        </td>
        <td *ngIf="canEdit">
          <div class="optionsButtons">
            <button pButton (click)="openEditModal(transaction)" icon="pi pi-pencil"
              class="p-button-rounded p-button-warning p-button-text"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Modal editar pendiente -->
<p-dialog [(visible)]="displayEditModal" [modal]="true" [closable]="false" [style]="{width: '50vw'}">
  <ng-template pTemplate="header">
    <h3>Editar Pendiente</h3>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="p-fluid">

      <!-- Tipo de Transacción -->
      <div class="p-field">
        <label for="typeTransaction">Tipo de Transacción</label>
        <p-dropdown [options]="transactionTypes" optionLabel="name" [(ngModel)]="selectedTransaction.type_transaction"
          placeholder="Seleccionar tipo">
        </p-dropdown>
      </div>

      <!-- Cliente -->
      <div class="p-field">
        <label for="cliente">Cliente</label>
        <p-dropdown id="cliente" [options]="clients" [(ngModel)]="selectedTransaction.customer" optionLabel="name"
          placeholder="Seleccionar cliente">
          <ng-template let-client pTemplate="item">
            {{ client.name }} 
          </ng-template>
          <ng-template let-client pTemplate="selectedItem">
            {{ client.name }}
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Divisas -->
      <div class="p-field">
        <label for="pair">Divisas</label>
        <p-dropdown id="pair" [options]="transactionPairs" optionLabel="name" [(ngModel)]="selectedTransaction.pair"
          placeholder="Seleccionar par">
        </p-dropdown>
      </div>

      <!-- Cantidad -->
      <div class="p-field">
        <label for="quantity">Cantidad</label>
        <input id="quantity" type="number" pInputText [(ngModel)]="selectedTransaction.quantity" />
      </div>

      <!-- Precio -->
      <div class="p-field">
        <label for="price">Precio</label>
        <input id="price" type="number" pInputText [(ngModel)]="selectedTransaction.price" />
      </div>

      <!-- Monto (Calculado, deshabilitado) -->
      <div class="p-field">
        <label for="mount">Monto</label>
        <input id="mount" type="number" pInputText [(ngModel)]="selectedTransaction.mount" />
      </div>

    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="closeEditModal()"></button>
    <button pButton label="Guardar" icon="pi pi-check" class="p-button-primary" (click)="saveTransaction()"></button>
  </ng-template>
</p-dialog>

<div class="card flex justify-content-center gap-2" *ngIf="displayDelete">
  <p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
      <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
      <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
  </p-confirmDialog>
</div>